am5.ready(function () {
  const mapEl = document.getElementById("websiteMap");
  if (!mapEl) return; // якщо елементу немає, пропускаємо весь блок

  var data = [
    { id: "NA", name: "North America", value: 17499, latitude: 40, longitude: -100, color: am5.color(0x0d6efd) },
    { id: "EU", name: "Europe", value: 14188, latitude: 54, longitude: 15, color: am5.color(0x0d2e62) },
    { id: "AP", name: "Asia Pacific", value: 9932, latitude: 30, longitude: 120, color: am5.color(0x343a40) },
    { id: "ME", name: "Middle East", value: 3784, latitude: 26, longitude: 50, color: am5.color(0xdc3545) },
    { id: "LA", name: "Latin America", value: 1892, latitude: -15, longitude: -60, color: am5.color(0x198754) }
  ];

  var totalValue = data.reduce((sum, item) => sum + item.value, 0);

  data.forEach(item => {
    item.percent = ((item.value / totalValue) * 100).toFixed(1);
  });

  var root = am5.Root.new("websiteMap");
  root.setThemes([am5themes_Animated.new(root)]);

  var chart = root.container.children.push(am5map.MapChart.new(root, {
    panX: "none",
    panY: "none",
    wheelX: "none",
    wheelY: "none"
  }));

  var polygonSeries = chart.series.push(
    am5map.MapPolygonSeries.new(root, {
      geoJSON: am5geodata_worldLow,
      exclude: ["AQ"]
    })
  );

  var bubbleSeries = chart.series.push(
    am5map.MapPointSeries.new(root, {
      valueField: "value",
      longitudeField: "longitude",
      latitudeField: "latitude"
    })
  );

  bubbleSeries.bullets.push(function (root, series, dataItem) {
    var container = am5.Container.new(root, {});

    var circle = container.children.push(
      am5.Circle.new(root, {
        radius: 35,
        fillOpacity: 0.9,
        fill: dataItem.dataContext.color,
        tooltipText: `{name}: [bold]{percent} %[/]`,
        cursorOverStyle: "pointer"
      })
    );

    circle.set("tooltip", am5.Tooltip.new(root, {}));
    circle.get("tooltip").label.setAll({
      fontSize: 20,
      fontWeight: "bold"
    });

    return am5.Bullet.new(root, {
      sprite: container,
      dynamic: true
    });
  });

  bubbleSeries.bullets.push(function (root, series, dataItem) {
    return am5.Bullet.new(root, {
      sprite: am5.Label.new(root, {
        text: "{percent}%",
        fill: am5.color(0xffffff),
        populateText: true,
        centerX: am5.p50,
        centerY: am5.p50,
        textAlign: "center"
      }),
      dynamic: true
    });
  });

  bubbleSeries.data.setAll(data);
});
